/* eslint-disable */
import cx from 'classnames';
import qs from 'qs';
import moment from 'moment-timezone';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Helmet } from "react-helmet";
import { Link } from 'react-router';
import { Button, Form, Glyphicon, FormGroup, ControlLabel, FormControl, Table, Modal } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import { mapDispatch } from '../../utils/util';

import OzModalButton from './OzModalButton';
import MistakeForm from './MistakeForm';

import './ReportMistake.css';
import {
  reportMistake,
} from '../../actions';


class ReportMistake extends Component {
  state = {};

  reportMistake(e, values) {
    console.log('report mistake', values);
    this.props.reportMistake(values)
      .then(resp => {
        if (resp.error) {
          alert('error while reporting mistake: ' + resp.error);
          return;
        }

        alert("Thanks! We'll take a look as soon as we can.");
        this.setState({ reporting: false });
      });
  }

  render() {
    return (
      <div className="ReportMistake">
        <OzModalButton
          modalTitle="Report a mistake"
          show={this.state.reporting}
          onShow={() => this.setState({ reporting: true })}
          onHide={() => this.setState({ reporting: false })}
          >

          <div className="small-gray-clickable">Report a mistake</div>

          <MistakeForm
            modal={true}
            values={{}}
            errors={this.props.errors.mistake}
            onCancel={() => this.setState({ reporting: false })}
            onSubmit={(e, values) => this.reportMistake(e, values)}
            buttonText="Report Mistake"
            cancelText="Cancel"
          />
        </OzModalButton>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    errors: state.errors,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    reportMistake,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ReportMistake);



/** WEBPACK FOOTER **
 ** ./src/components/partials/ReportMistake.js
 **/